var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-tabs",
    {
      attrs: { type: "card" },
      on: { "tab-click": _vm.handleClick },
      model: {
        value: _vm.activeName,
        callback: function($$v) {
          _vm.activeName = $$v
        },
        expression: "activeName"
      }
    },
    [
      _c(
        "el-tab-pane",
        { attrs: { label: "组装件", name: "first" } },
        [
          _c("swb-asmbl-acc-def-list-select", {
            ref: "swb_asmbl_acc_def_list_select",
            attrs: {
              checkIds: _vm.asmblIds,
              filter: _vm.asmblFilter,
              checkBox: true,
              needDisabled: true
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-tab-pane",
        { attrs: { label: "入选商品", name: "second" } },
        [
          _c("swb-adopted-device-list-select", {
            ref: "swb_adopted_device_list_select",
            attrs: {
              showAccFlag: true,
              showCatBrandModelFixedSpecTable: true,
              checkBox: true,
              showAssetDefFlag: true,
              checkIds: _vm.deviceIds,
              filter: _vm.deviceFilter
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9020c6fe", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9020c6fe","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/asmblAcc/MerchtDevcDefRelMack.vue
// module id = 2420
// module chunks = 0